import { render } from "./SystemContent.vue?vue&type=template&id=02a039b0&scoped=true"
import script from "./SystemContent.vue?vue&type=script&lang=js"
export * from "./SystemContent.vue?vue&type=script&lang=js"

import "./SystemContent.vue?vue&type=style&index=0&id=02a039b0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anderson\\Documents\\GitHub\\px40-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02a039b0"]])

export default __exports__